import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import {formatToIntegerValue} from "../../../../common/utils";

const FieldPhone = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'settings-form-phone',
    defaultMessage: 'Phone'
  });
  const [field, meta] = useField({name: 'phone'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      onChange={e => {
        field.onChange(field.name)(formatToIntegerValue(e));
      }}
      disabled={true}
    />
  );
};

export default FieldPhone;
